// Messages rendered on /auth and /login when a logout or Auth0 error sends the user back
// with a `logout_message` query param. Keys are the values written by AuthService.
export const LOGOUT_MESSAGES = {
  access_denied: 'Access denied. Your account may be blocked or you do not have permission to access this application.',
  user_blocked: 'Your account has been blocked. Please contact support for assistance.',
  login_required: 'Please log in to continue.',
  consent_required: 'Additional consent is required.',
  auth0error: 'Authentication failed. Please try again.',
  expired: 'Your session has expired. Please log in.',
  deactivated: 'Your account has been deactivated. Please contact your administrator.',
  axiumLogin: 'Please log in through your practice management integration.',
  api_unavailable: 'We could not reach Rhinogram to finish signing you in. Please try again.',
};

// Messages that describe a transient failure on our side rather than a problem with the user's
// credentials. Retrying from these should reuse the live Auth0 session, not force a new login.
export const RETRY_WITHOUT_REAUTH = ['api_unavailable'];

export function shouldForceLoginFor(key) {
  return Boolean(key) && !RETRY_WITHOUT_REAUTH.includes(key);
}

/**
 * Resolve a `logout_message` key to display text.
 * Unknown non-empty keys fall back to the generic auth error so the user always sees something.
 * @param {string|null|undefined} key
 * @returns {string|null}
 */
export function getLogoutMessage(key) {
  if (!key) return null;
  return LOGOUT_MESSAGES[key] || LOGOUT_MESSAGES.auth0error;
}
